module.exports = __webpack_public_path__ + "img/biohazard-sign.172546ce.svg";